/**
 * Images locales pour les catégories Explorer (accueil) — aligné mobile-client.
 */
import catCoiffure from '../assets/categories/cat-coiffure.png';
import catTresses from '../assets/categories/cat-tresses.png';
import catTissage from '../assets/categories/cat-tissage.png';
import catBarbier from '../assets/categories/cat-barbier.png';
import catOnglerie from '../assets/categories/cat-onglerie.png';
import catMaquillage from '../assets/categories/cat-maquillage.png';
import catCils from '../assets/categories/cat-cils.png';
import catEpilation from '../assets/categories/cat-epilation.png';
import catSoins from '../assets/categories/cat-soins.png';
import catMassage from '../assets/categories/cat-massage.png';
import catSpa from '../assets/categories/cat-spa.png';
import catBienetre from '../assets/categories/cat-bienetre.png';
import catTatouage from '../assets/categories/cat-tatouage.png';
import catPiercing from '../assets/categories/cat-piercing.png';

const IMG = {
  coiffure: catCoiffure,
  tresses: catTresses,
  tissage: catTissage,
  barbier: catBarbier,
  onglerie: catOnglerie,
  maquillage: catMaquillage,
  cils: catCils,
  epilation: catEpilation,
  soins: catSoins,
  massage: catMassage,
  spa: catSpa,
  bienetre: catBienetre,
  tatouage: catTatouage,
  piercing: catPiercing,
};

const RULES = [
  { keys: ['tresse', 'natte'], img: IMG.tresses },
  { keys: ['tissage', 'extension'], img: IMG.tissage },
  { keys: ['barbier', 'barbe', 'homme'], img: IMG.barbier },
  { keys: ['ongle', 'manucure', 'onglerie', 'nail'], img: IMG.onglerie },
  { keys: ['maquillage', 'makeup', 'make-up'], img: IMG.maquillage },
  { keys: ['cil', 'sourcil'], img: IMG.cils },
  { keys: ['epilat', 'épilat', 'cire'], img: IMG.epilation },
  { keys: ['tatouage', 'tattoo', 'ink'], img: IMG.tatouage },
  { keys: ['piercing', 'percing'], img: IMG.piercing },
  { keys: ['spa'], img: IMG.spa },
  { keys: ['bien-etre', 'bien etre', 'bienetre', 'wellness'], img: IMG.bienetre },
  { keys: ['massage'], img: IMG.massage },
  { keys: ['soin', 'visage', 'peau'], img: IMG.soins },
  { keys: ['coiffure', 'cheveu', 'brushing', 'coupe'], img: IMG.coiffure },
];

function normalize(str = '') {
  return String(str)
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
}

export function getCategoryImage(name = '') {
  const lower = normalize(name);
  for (const rule of RULES) {
    if (rule.keys.some((k) => lower.includes(normalize(k)))) {
      return rule.img;
    }
  }
  return IMG.coiffure;
}
